import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Carousel from 'brastrap/common/carousel/Carousel';
import {
  FormattedNumber,
  defineMessages,
  intlShape,
  injectIntl,
} from 'react-intl';
import Container from 'brastrap/common/container/Container';

const ProductPageRecentlyViewedItems = ({
  locale,
  currency,
  isMobile,
  details,
  intl: { formatMessage },
  styleCode,
}) => {
  const SLIDES_TO_SHOW = isMobile ? 2 : 4;

  const [recentlyViewedItems, setRecentlyViewedItems] = useState(null);

  useEffect(() => {
    if (window && typeof window !== 'undefined') {
      setRecentlyViewedItems(
        JSON.parse(localStorage.getItem('recentlyViewedItems'))
      );
    }
  }, [details]);

  /**
   * Handles clicking the clear history button on the recently viewed items carousel
   */
  function handleClearHistoryClick() {
    localStorage.removeItem('recentlyViewedItems');
    setRecentlyViewedItems(null);
  }

  const messages = defineMessages({
    clearHistory: {
      id: 'product-page-recently-viewed-items.clear-history',
      defaultMessage: 'Clear history',
    },
    emptyState: {
      id: 'product-page-recently-viewed-items.empty-state',
      defaultMessage:
        "You currently have no recently viewed items. We'll save the styles you've viewed here as you browse.",
    },
  });

  const carouselOptions = {
    labels: { next: { heading: '' }, prev: { heading: '' } },
    responsive: [],
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SHOW,
    infinite: false,
    arrows: recentlyViewedItems?.length > SLIDES_TO_SHOW,
  };

  const recentlyViewedItem = item => (
    <a
      onClick={() =>
        item.styleCode === styleCode ? window.scrollTo(0, 0) : {}
      }
      className="c-product-page-recently-viewed__item"
      href={`${locale === 'en-US' ? `/us${item.url}` : `${item.url}`}`}
    >
      <img src={item.image} />
      <h1 className="c-product-page-recently-viewed__code">
        {item.styleColourCode}
      </h1>
      <h3 className="c-product-page-recently-viewed__name">{item.name}</h3>
      <h3 className="c-product-page-recently-viewed__price">
        <FormattedNumber
          value={item.price}
          style="currency"
          currency={currency}
        />
      </h3>
    </a>
  );

  const arrayOfEmptyItems =
    recentlyViewedItems?.length < SLIDES_TO_SHOW
      ? [...Array(SLIDES_TO_SHOW - recentlyViewedItems?.length)]
      : [];

  return (
    <Container
      id="recently-viewed-rail"
      title={'Recently viewed'}
      adjacentItem={
        <button
          className="c-product-page-recently-viewed__button"
          onClick={handleClearHistoryClick}
        >
          {formatMessage(messages.clearHistory)}
        </button>
      }
    >
      <div className="c-product-page-recently-viewed__carousel">
        <Carousel {...carouselOptions} lazyLoad>
          {recentlyViewedItems
            ?.reverse()
            .concat(arrayOfEmptyItems)
            .map(item => (
              <div className="c-product-page-recently-viewed__itemContainer">
                {item?.url && item?.image ? recentlyViewedItem(item) : <></>}
              </div>
            ))}
        </Carousel>
        {!recentlyViewedItems ? (
          <div className="c-product-page-recently-viewed__emptyStateContainer">
            <div className="c-product-page-recently-viewed__emptyState">
              {formatMessage(messages.emptyState)}
            </div>
          </div>
        ) : null}
      </div>
    </Container>
  );
};

ProductPageRecentlyViewedItems.propTypes = {
  locale: PropTypes.string,
  currency: PropTypes.string,
  isMobile: PropTypes.bool,
  details: PropTypes.element,
  intl: intlShape,
  styleCode: PropTypes.string,
};

export default injectIntl(ProductPageRecentlyViewedItems);
